import { InjectionToken } from '@angular/core';

import { HelpTranslationLinkMapKey } from '@recruitee/help-articles';

export type TutorialStep = {
  imgUrl?: string;
  imgUrl2x?: string;
  youtubeVideoId?: string;
  title: string;
  description: string;
  articleLinkKey?: HelpTranslationLinkMapKey;
  isStep0?: boolean;
};

export type TutorialDialogContext =
  | 'multilang_intro'
  | 'multilang_offer'
  | 'referrals_onboarding'
  | 'requisitions_intro'
  | 'requisitions_job';

export const AssetsProvider = new InjectionToken('AssetsProvider');
